/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Slider from "react-slick";
import moment from "moment";
import classnames from "classnames";
import { Project, PropertyDetails, Unit } from "../../core/api/models/project";
import BottomPagination from "../../core/components/pagination/BottomPagination";
import { PaginatedApiResponse } from "../../core/api/models/response";
import RequirementPropertyDetailPage from "../requirement/components/RequirementPropertyDetail";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../api";
import { toastr } from "react-redux-toastr";
import { AppPermissions, convertPascalCaseToWords, htmlDecode, SortOrder, useHasPermission } from "../../core";
import { LeadRequirement } from "../../core/api/models/requirement";
import { ContainerLoader } from "../../components/loader";
import PropertyDetailPage from "../property-details/PropertyDetailPage";
import { RenderFieldDetails } from "../create-proposal/components/selected-properties-render-field-details";
import SortByAscendingIcon from "../../assets/images/sort-by-ascending-icon";
import SortByDescendingIcon from "../../assets/images/sort-by-descending-icon";
import ListViewIcon from "../../assets/images/list-view-icon";
import MapViewIcon from "../../assets/images/map-view-icon";
import { SearchPropertiesMapView } from "./search-properties-mapview";
import ArrowDownIcon from "../../assets/images/arrow-down";
import { SearchPropertiesDropdownTable } from "./search-properties-dropdown-table";

const SearchProperty: React.FunctionComponent<{
  properyData?: PaginatedApiResponse<Project>;
  page?: number;
  perPage?: number;
  setPage?: (pg: number) => void;
  setPerPage?: (pg: number) => void;
  requirementVersion?: number;
  requirementId?: string;
  reload?: () => void;
  onSort?: (sortOrder?: SortOrder) => void;
  sortOrder?: SortOrder;
  configuration: LeadRequirement;
  sortList?: any[];
  allLoaded: boolean;
  loading: boolean;
  setCreateProposalModal?: (spv: PropertyDetails[]) => void;
  hasAnyProposalApproved?: boolean;
}> = (props) => {
  const [projectDetailModal, setProjectDetailModal] = React.useState<{
    isOpen?: boolean;
    projectId?: string;
    searchData?: Project;
    availableUnit?: number;
    allUnit?: number;
  }>({});
  const [propertyDetailModal, setPropertyDetailModal] = React.useState<{
    isOpen?: boolean;
    propertyId?: string;
  }>({});
  const [propDropdown, setPropDropdown] = React.useState<number | null>(null);
  const [seletedView, setSelectedView] = React.useState("list");

  const canViewProject = useHasPermission(AppPermissions.ViewProject);
  const canViewProperty = useHasPermission(AppPermissions.ViewProperty);

  const [selectedProperty, setSelectedProperty] = React.useState<
    PropertyDetails[]
  >();
  const [dropPos, setDropPos] = React.useState<{
    open: boolean;
    x: string;
    y: string;
    id: string;
    fieldName: string;
  }>();
  const [selecteStatus, setPropertyStatusData] = React.useState<any>();
  React.useEffect(() => {
    const requirementId = props.requirementId ? props.requirementId : "";
    if (props?.requirementId) {
      const fetchData = async () => {
        const response = await api.proposal.getPropertyStatusByRequirementId(
          requirementId
        );
        setPropertyStatusData(response);
      };
      fetchData();
    }
  }, [props.requirementId]);
  const onSelectedAllProjects = (selected: boolean) => {
    if (props.properyData && props.properyData.data) {
      const allValues: PropertyDetails[] = props.properyData?.data?.reduce(
        (values, item) => {
          const units = item?.unitDetails?.filter(
            (x) =>
              !!item?.properties?.find(
                (p) => p.propertyID?.toString() === x.propertyID?.toString()
              )
          )
          if (selected && units) {
            values.push(
              ...units?.map((ut: Unit) => {
                const property = ut.propertyID
                  ? item?.properties?.find(
                    (p) =>
                      p.propertyID?.toString() === ut.propertyID?.toString()
                  )
                  : undefined;
                return {
                  floor: ut.floorName,
                  unitId: ut.unitID,
                  unitName: ut.unitName,
                  area: ut.unitArea,
                  interiorType: property?.attribute?.interiorType,
                  quotedRent: property?.attribute?.quotedRentPerSqFtPerMonth,
                  currentStatus: property?.propertyAvailableStatus,
                  availableFrom: property?.availablefromdate,
                  projectId: item?._id,
                  propertyId: property?._id,
                  propertyName: property?.propertyName,
                  propertyAddress: property?.propertyAddress1,
                  propertyCoverImage: property?.propertyCoverImage,
                  propertySqrFeet: property?.propertySqrFeet,
                  developer: item?.projectBuilderName,
                  pricePerSqft: property?.pricePerSqft,
                  availableUnits: property?.availableUnits,
                  requirementVersion: props.requirementVersion,
                  projectName: item?.projectName,
                  latitude: property?.proLatitude,
                  longitude: property?.proLongitude,
                  cityName: property?.cityName,
                  cityLocName: property?.cityLocName,
                };
              })
            );
          }

          return values;
        },
        [] as PropertyDetails[]
      );
      setSelectedProperty(allValues);
    }
  };

  const onAllSelected = (selected: boolean, project: Project) => {
    const allValues = !selected
      ? ([] as PropertyDetails[])
      : (project?.unitDetails
        ?.filter(
          (x) =>
            !!project?.properties?.find(
              (p) => p.propertyID?.toString() === x.propertyID?.toString()
            )
        )
        ?.sort((a, b) => (a.floorName < b.floorName ? -1 : 1))
        ?.map((ut: Unit) => {
          const property = ut.propertyID
            ? project?.properties?.find(
              (p) => p.propertyID?.toString() === ut.propertyID?.toString()
            )
            : undefined;
          return {
            floor: ut.floorName,
            unitId: ut.unitID,
            unitName: ut.unitName,
            area: ut.unitArea,
            interiorType: property?.attribute?.interiorType,
            quotedRent: property?.attribute?.quotedRentPerSqFtPerMonth,
            currentStatus: property?.propertyAvailableStatus,
            availableFrom: property?.availablefromdate,
            projectId: project?._id,
            propertyId: property?._id,
            propertyName: property?.propertyName,
            propertyAddress: property?.propertyAddress1,
            propertyCoverImage: property?.propertyCoverImage,
            propertySqrFeet: property?.propertySqrFeet,
            developer: project?.projectBuilderName,
            pricePerSqft: property?.pricePerSqft,
            availableUnits: property?.availableUnits,
            requirementVersion: props.requirementVersion,
            projectName: project?.projectName,
            latitude: property?.proLatitude,
            longitude: property?.proLongitude,
          };
        }) as PropertyDetails[]);
    setSelectedProperty([
      ...(selectedProperty?.filter(
        (p) => p.projectId?.toString() !== project?._id?.toString()
      ) || []),
      ...(allValues || []),
    ]);
  };

  const onSelect = (ut: Unit, sel: boolean, project: Project) => {
    if (sel) {
      const property = ut.propertyID
        ? project?.properties?.find(
          (p) => p.propertyID?.toString() === ut.propertyID?.toString()
        )
        : undefined;
      setSelectedProperty([
        ...(selectedProperty || []),
        {
          floor: ut.floorName,
          unitId: ut.unitID,
          unitName: ut.unitName,
          area: ut.unitArea,
          interiorType: property?.attribute?.interiorType,
          quotedRent: property?.attribute?.quotedRentPerSqFtPerMonth,
          currentStatus: property?.propertyAvailableStatus,
          availableFrom: property?.availablefromdate,
          projectId: project?._id,
          propertyId: property?._id,
          propertyName: property?.propertyName,
          propertyAddress: property?.propertyAddress1,
          propertyCoverImage: property?.propertyCoverImage,
          propertySqrFeet: property?.propertySqrFeet,
          developer: project?.projectBuilderName,
          pricePerSqft: property?.pricePerSqft,
          availableUnits: property?.availableUnits,
          requirementVersion: props.requirementVersion,
          projectName: project?.projectName,
          latitude: property?.proLatitude,
          longitude: property?.proLongitude,
        },
      ]);
    } else {
      setSelectedProperty(
        selectedProperty?.filter((val) => val.unitId !== ut.unitID) || []
      );
    }
  };

  const {
    performAction: createShortList,
    isPerforming: isSaving,
  } = usePerformAction(
    () =>
      api.shortlist.createShortList({
        requirementId: props.requirementId!,
        propertyDetails: selectedProperty!,
      }),
    () => {
      toastr.success("Success", "Added to Shortlist");
      props?.setCreateProposalModal?.(selectedProperty!);
      setSelectedProperty(undefined);
      props.reload?.();
    },
    () => {
      toastr.error("Error", "Unable to add to Shortlist");
    }
  );



  const ordinalSuffixOf = (i: number) => {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  };

  const locations = props.properyData?.data?.map((x, index) => {
    return {
      lat: parseFloat(x.projectLatitude!),
      lng: parseFloat(x.projectLongitude!),
      // name: x.projectAddress1,
      name: (index + 1).toString(),
    };
  });

  if (props.allLoaded && (props.loading || props.properyData === undefined)) {
    return <ContainerLoader></ContainerLoader>;
  }

  const dropdownClick = (event: any, id: string, fieldName: string) => {
    const pos = event.target.getBoundingClientRect();
    const x = pos.x + "px";
    const y = pos.y + pos.height + "px";
    setDropPos({ open: !dropPos?.open, x, y, id, fieldName });
  };

  return !!props.properyData?.data?.length ? (
    <>
      <div
        className="py-3 px-2 border-top border-bottom d-flex align-items-center mb-1"
        style={{ background: "rgba(160, 160, 160, 0.06)" }}
      >
        <div className="py-1">
          <input
            type="checkbox"
            name={"ProjectCheckAll"}
            id={"ProjectCheckAll"}
            disabled={props?.hasAnyProposalApproved}
            onChange={(e) => onSelectedAllProjects(e.target.checked)}
            checked={
              props.properyData?.data?.every((project) => {
                const unitDetails = project.unitDetails?.filter(
                  (x) =>
                    !!project?.properties?.find(
                      (p) => p.propertyID?.toString() === x.propertyID?.toString()
                    )
                );
                return (
                  selectedProperty?.filter((ff) => ff.projectId === project._id)?.length ===
                  unitDetails?.length && !!unitDetails?.length
                );
              }) && !!props.properyData?.data?.length
            }
          />
          <label htmlFor={"ProjectCheckAll"}></label>
        </div>
        <div className="font-sm text-gray-500">
          <span className="text-gray-700 font-weight-semibold">
            {props.properyData?.itemsCount}
          </span>{" "}
          Properties,{" "}
          <span className="text-gray-700 font-weight-semibold">
            {props.properyData?.count}
          </span>{" "}
          Projects
        </div>
        {seletedView === "list" && (
          <div
            className="inline-flex font-xs text-gray-500 border-left ml-4 pl-4 cursor-pointer"
            onClick={() => {
              props.onSort?.(
                props.sortOrder === SortOrder.ASC
                  ? SortOrder.DESC
                  : SortOrder.ASC
              );
            }}
          >
            {props.sortOrder === SortOrder.ASC ? (
              <SortByAscendingIcon />
            ) : (
              <SortByDescendingIcon />
            )}
            <span className="ml-1">Sort</span>
          </div>
        )}

        <div className="ml-auto">
          <ul className="click-tab bg-white d-flex list-unstyled mb-0">
            <li
              className={classnames({
                "px-3 py-2 border border-right-0 rounded-left cursor-pointer": true,
                active: seletedView === "list",
              })}
              onClick={() => setSelectedView("list")}
            >
              <ListViewIcon />
            </li>
            <li
              className={classnames({
                "px-3 py-2 border rounded-right cursor-pointer": true,
                active: seletedView === "map",
              })}
              onClick={() => setSelectedView("map")}
            >
              <MapViewIcon />
            </li>
          </ul>
        </div>
      </div>

      {seletedView === "map" && (
        <SearchPropertiesMapView
          locations={locations}
          properyData={props.properyData}
        />
      )}

      {seletedView === "list" && (
        <div className="table-responsive proposal-table-outer">
          <table className="table w-100">
            {props.properyData?.data?.map((item, index) => {
              const gradeC = item.grade === "C" ? true : false;
              const statusItem = selecteStatus?.proposedPropertyStatus.filter(
                (el: any) =>
                  item.properties?.some((prop) => {
                    const match = prop._id === el.propertyId;
                    return match;
                  })
              );
              const unitDetails = item.unitDetails
                ?.filter(
                  (x) =>
                    !!item?.properties?.find(
                      (p) =>
                        p.propertyID?.toString() === x.propertyID?.toString()
                    )
                )
                ?.sort((a, b) => (a.floorName < b.floorName ? -1 : 1));

              const floors = [
                ...new Set(unitDetails?.map((f) => f.floorName)),
              ].sort();

              const properties = item.properties
                ?.map((p) => {
                  return {
                    ...p,
                    floorName:
                      unitDetails?.find(
                        (u) =>
                          p.propertyID?.toString() === u.propertyID?.toString()
                      )?.floorName || "",
                  };
                })
                ?.sort((a, b) => (a.floorName < b.floorName ? -1 : 1));

              const availableUnit = unitDetails?.filter((x) =>
                item.properties?.find(
                  (p) =>
                    p.propertyID?.toString() === x.propertyID?.toString() &&
                    (p.propertyAvailableStatus === "available" || p.propertyAvailableStatus === "availablefrom")
                )
              )?.length;

              const allUnit = unitDetails?.filter((x) =>
                item.properties?.find(
                  (p) => p.propertyID?.toString() === x.propertyID?.toString()
                )
              )?.length;

              const isShortListed = !!props.sortList?.find(
                (x) => x.propertyDetailsFromProject?.projectId === item._id
              );

              return (
                <>
                  <tr
                    className={`require-row ${propDropdown === index ? "active" : ""
                      }`}
                  >
                    <td
                      className="py-2 border-bottom font-sm"
                      style={{ maxWidth: "40px", width: "40px" }}
                    >
                      <div className="py-1">
                        <input
                          type="checkbox"
                          name={`properyCheck-${item._id}`}
                          id={`properyCheck-${item._id}`}
                          onChange={(e) =>
                            onAllSelected(e.target.checked, item)
                          }
                          checked={
                            selectedProperty?.filter(
                              (ff) => ff.projectId === item._id
                            )?.length === unitDetails?.length &&
                            !!unitDetails?.length
                          }
                          disabled={props?.hasAnyProposalApproved}
                        />
                        <label htmlFor={`properyCheck-${item._id}`}></label>
                      </div>
                    </td>
                    <td
                      className="py-2 border-bottom font-sm"
                      style={{ maxWidth: "90px" }}
                      onClick={() =>
                        setProjectDetailModal({
                          isOpen: true,
                          projectId: item?._id,
                          searchData: item,
                          availableUnit,
                          allUnit,
                        })
                      }
                    >
                      <div className="py-1 cursor-pointer">
                        <img
                          src={
                            item.projectBannerImage ||
                            require(`../../assets/images/color-noimage-lg.png`)
                          }
                          alt={item.projectName}
                          width={59}
                          height={45}
                          className="img-cover"
                        />
                      </div>
                    </td>
                    <td
                      className="py-2 border-bottom font-sm"
                      style={{ width: "290px", maxWidth: "290px" }}
                      onClick={() =>
                        setProjectDetailModal({
                          isOpen: true,
                          projectId: item?._id,
                          searchData: item,
                          availableUnit,
                          allUnit,
                        })
                      }
                    >
                      <div className="py-1 w-100 px-3">
                        <div className="font-sm text-truncate cursor-pointer">
                          {item.projectName}
                        </div>
                        <div className="font-xs text-gray-500">
                          {htmlDecode(item.projectAddress1)}
                        </div>
                        {isShortListed && (
                          <span className="tag--active font-xxs mr-2">
                            Short Listed
                          </span>
                        )}
                        {item?.optionDueToLeaseExpiry && props.configuration?.includeLeaseExpiry && (
                          <span className="tag--leaseexpired font-xxs">
                            Option due to lease expiry
                          </span>
                        )}
                        <span className="tag--pending font-xxs spaced-span m-2">
                          {statusItem &&
                            statusItem.length &&
                            statusItem[0]?.proposalStatus !== undefined
                            ? "Proposal" + " " + statusItem[0]?.proposalStatus
                            : ""}
                        </span>
                      </div>
                    </td>

                    <td className="py-2 border-bottom font-sm">
                      <div className="py-1 font-xs text-gray-800">
                        <span className="text-gray-500">Developer:</span>{" "}
                        {htmlDecode(item.projectBuilderName)}
                      </div>
                    </td>
                    <td className="py-2 border-bottom font-sm">
                      <div className="py-1" style={{ whiteSpace: "nowrap" }}>
                        <div className="font-xxs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                          <b className="text-gray-800 font-xs">
                            {String(availableUnit).padStart(2, "0")}
                          </b>
                          /{String(allUnit).padStart(2, "0")}
                          Matching
                        </div>
                        <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                          Unit matching :{" "}
                          {String(availableUnit).padStart(2, "0")}
                        </div>
                        <div className="font-xs text-gray-600 border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                          Floor matching :{" "}
                          {String(availableUnit).padStart(2, "0")}
                        </div>
                        {gradeC ? (
                          <div className="font-xs bg-primary text-white font-weight-bold border rounded-pill d-inline-flex py-1 px-2 align-items-center mr-2 mb-2">
                            Grade C
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                    <td
                      className="py-2 border-bottom font-sm align-items-center font-weight-semibold"
                      style={{ width: "80px" }}
                    >
                      {!!selectedProperty?.filter(
                        (x) => x.projectId === item._id
                      )?.length && (
                          <div className="border border-primary  px-1 px-2 py-1 text-primary w-75 selectproperty-ico font-md align-items-center rounded-lg d-flex justify-content-center">
                            {
                              selectedProperty?.filter(
                                (x) => x.projectId === item._id
                              )?.length
                            }
                            <svg
                              width="16"
                              height="21"
                              viewBox="0 0 25 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="ml-1"
                            >
                              <g id="Group">
                                <path
                                  id="Vector"
                                  d="M20.7748 0.846845C18.0794 -0.593747 14.5243 -0.156234 12.2903 1.85387C10.0454 -0.154626 6.48464 -0.587461 3.79831 0.846845C1.45711 2.0882 0 4.4655 0 7.04673C0 7.78581 0.12279 8.52021 0.340012 9.15287C1.48591 14.1129 8.84221 20.64 12.2903 20.64C15.7309 20.64 23.0816 14.1123 24.2078 9.23692C24.4493 8.51948 24.5725 7.78683 24.5725 7.046C24.5727 4.4655 23.1169 2.08732 20.7748 0.846845ZM22.5345 8.76258C21.4683 13.3786 14.5215 18.8996 12.2903 18.8996C9.80714 18.8996 3.0414 13.1158 2.01347 8.67867C1.82987 8.14351 1.74157 7.59563 1.74157 7.04775C1.74157 5.1122 2.84172 3.32341 4.61223 2.38435C5.43668 1.94275 6.37457 1.71486 7.32268 1.71486C8.99146 1.71486 10.5623 2.4228 11.6338 3.6602L12.2979 4.42019L12.952 3.6602C14.6207 1.72377 17.6859 1.16698 19.9642 2.38435C21.7347 3.32341 22.835 5.1122 22.835 7.04775C22.8314 7.59461 22.7425 8.14263 22.5345 8.76258Z"
                                  fill="#4161c8"
                                />
                              </g>
                            </svg>
                          </div>
                        )}
                    </td>
                    <td className="py-2 border-bottom font-sm">
                      <div
                        className="py-1 cursor-pointer"
                        onClick={() =>
                          propDropdown === index
                            ? setPropDropdown(null)
                            : setPropDropdown(index)
                        }
                      >
                        <ArrowDownIcon />
                      </div>
                    </td>
                  </tr>
                  {propDropdown === index && (
                    <tr>
                      <td colSpan={7}>
                        <SearchPropertiesDropdownTable
                          selectedProperty={selectedProperty}
                          setPropertyDetailModal={setPropertyDetailModal}
                          sortList={props.sortList}
                          properties={properties}
                          dropdownClick={dropdownClick}
                          statusItem={statusItem}
                          dropPos={dropPos}
                          floors={floors}
                          item={item}
                          onAllSelected={onAllSelected}
                          onSelect={onSelect}
                          ordinalSuffixOf={ordinalSuffixOf}
                          unitDetails={unitDetails}
                          configuration={props.configuration}
                        />
                      </td>
                    </tr>
                  )}
                </>
              );
            })}
          </table>
        </div>
      )}
      <div className="d-flex justify-content-between mt-5">
        <div>
          <BottomPagination
            currentPage={props.page || 1}
            totalPages={props.properyData?.totalPages || 0}
            onPageChange={(pg: number) => {
              props.setPage?.(pg);
            }}
            perPage={props.perPage || 20}
            onPerPageChange={(pg: number) => {
              props.setPerPage?.(pg);
            }}
            count={props.properyData?.count}
            label="Record"
          />
        </div>
        {!props.hasAnyProposalApproved && <div>
          <button
            type="button"
            onClick={createShortList}
            className="btn bg-primary px-3 font-normal font-weight-bold text-white"
            disabled={isSaving || !selectedProperty?.length}
          >
            Add to Shortlist & Create Proposal
          </button>
        </div>}
      </div>
      {projectDetailModal.isOpen && canViewProject && (
        <RequirementPropertyDetailPage
          onClose={() => setProjectDetailModal({})}
          projectId={projectDetailModal.projectId}
          searchData={projectDetailModal.searchData}
          requirementVersion={props.requirementVersion}
          requirementId={props.requirementId}
          availableUnit={projectDetailModal.availableUnit}
          allUnit={projectDetailModal.allUnit}
          configuration={props.configuration}
          reload={props.reload}
          showDetailsOnly={props.hasAnyProposalApproved}
        ></RequirementPropertyDetailPage>
      )}
      {propertyDetailModal.isOpen && canViewProperty && (
        <PropertyDetailPage
          onClose={() => setPropertyDetailModal({})}
          projectId={propertyDetailModal.propertyId}
        ></PropertyDetailPage>
      )}
    </>
  ) : (
    <></>
  );
};

export default SearchProperty;

